const shipmentDetails = {
  'shipmentDetails.shipmentDetails': 'تفاصيل إشعار الشحن',
  'shipmentDetails.updateShipmentStatus': 'تعديل حالة الشحن',
  'shipmentDetails.saveLogistics': 'إضافة سجل شحن',
  'shipmentDetails.updateLogistics': 'تعديل سجل الشحن',

  'shipmentDetails.orderId': 'رقم الطلب',
  'shipmentDetails.shipmentId': 'رقم إشعار الشحن',
  'shipmentDetails.shipmentId.placeholder': 'الرجاء إدخال رقم إشعار الشحن',
  'shipmentDetails.shipmentMethod': 'طريقة الشحن',
  'shipmentDetails.shipmentDate': 'تاريخ الشحن',
  'shipmentDetails.shipmentStatus': 'حالة الشحن',
  'shipmentDetails.shipmentStatusName': 'حالة الشحن',

  'shipmentDetails.recipientInfo': 'معلومات الاستلام',
  'shipmentDetails.recipientName': 'اسم المستلم',
  'shipmentDetails.phone': 'رقم الاتصال',
  'shipmentDetails.postalCode': 'الرمز البريدي',
  'shipmentDetails.email': 'البريد الإلكتروني',
  'shipmentDetails.address': 'عنوان الاستلام',

  'shipmentDetails.logisticsList': 'قائمة سجلات الشحن',
  'shipmentDetails.logisticsList.trackingNumber': 'رقم تتبع الشحن',
  'shipmentDetails.logisticsList.trackingNumber.placeholder': 'الرجاء إدخال رقم التتبع',
  'shipmentDetails.logisticsList.shipmentId': 'رقم إشعار الشحن',
  'shipmentDetails.logisticsList.carrierName': 'الشركة الناقلة',
  'shipmentDetails.logisticsList.carrierName.placeholder': 'الرجاء إدخال اسم الناقل',
  'shipmentDetails.logisticsList.deliveryStatus': 'حالة التوصيل',
  'shipmentDetails.logisticsList.shipmentDate': 'تاريخ الشحن',
  'shipmentDetails.logisticsList.shipmentDate.placeholder': 'حدد تاريخ الشحن',
  'shipmentDetails.logisticsList.estimatedArrival': 'تاريخ الوصول المتوقع',
  'shipmentDetails.logisticsList.estimatedArrival.placeholder': 'حدد تاريخ الوصول المتوقع',
  'shipmentDetails.logisticsList.actualArrival': 'تاريخ الوصول الفعلي',
  'shipmentDetails.logisticsList.actualArrival.placeholder': 'حدد تاريخ الوصول الفعلي',
  'shipmentDetails.logisticsList.shipper': 'المُرسل',
  'shipmentDetails.logisticsList.shipper.placeholder': 'الرجاء إدخال اسم المُرسل',
  'shipmentDetails.logisticsList.contact': 'معلومات الاتصال',
  'shipmentDetails.logisticsList.contact.placeholder': 'الرجاء إدخال معلومات الاتصال',
  'shipmentDetails.logisticsList.trackingRecords': 'سجل التتبع',
  'shipmentDetails.logisticsList.update': 'تحديث',

  'shipmentDetails.trackingRecords.trackingTime': 'وقت التتبع',
  'shipmentDetails.trackingRecords.trackingLocation': 'موقع التتبع',
  'shipmentDetails.trackingRecords.remark': 'ملاحظات',
  'shipmentDetails.trackingRecords.attachment': 'مرفقات',
  'shipmentDetails.trackingRecords.update': 'تحديث السجل',
  'shipmentDetails.trackingRecords.location': 'الموقع',
  'shipmentDetails.trackingRecords.location.placeholder': 'أدخل الموقع',
  'shipmentDetails.trackingRecords.time': 'الوقت',
  'shipmentDetails.trackingRecords.time.placeholder': 'حدد الوقت',

  'shipmentDetails.productList': 'قائمة السلع المشحونة',
};

export default shipmentDetails;
